<template>
  <div
    v-if="allowedPeriods.length > 1"
    class="f-flex f-items-center f-space-x-4 f-mb-5"
  >
    <label :for="id" class="f-mt-1">{{ $t("items.period.label") }}</label>
    <select
      :id="id"
      v-model="value"
      @change="$emit('periodChanged', $event.target.value)"
      class="f-form-select f-mt-1 f-block f-w-full f-py-1 f-text-base f-border-gray-300 focus:f-outline-none f-rounded-md f-text-gray-700"
    >
      <option
        v-for="option in periodOptions"
        :value="option.value"
        :key="option.value"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import UrlParser from "@/module/Utils/UrlParser";

interface ComponentData {
  value: string | null;
}

export default Vue.extend({
  name: "Period",

  props: {
    allowedPeriods: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
  },

  data(): ComponentData {
    return {
      value: null,
    };
  },

  computed: {
    id(): string {
      return this.$id("period");
    },

    periodOptions(): Array<{ value: string; text: string }> {
      const periodOptions: Array<{ value: string; text: string }> = [];

      this.allowedPeriods.forEach((item: string) => {
        const [count, period] = item.split(" ");

        periodOptions.push({
          value: item,
          text: this.$tc("items.periods." + period, Number(count)).toString(),
        });
      });

      return periodOptions;
    },
  },

  mounted(): void {
    const periods = this.periodOptions;

    if (periods.length > 0) {
      this.value = periods[0].value;
    }

    const urlParser = UrlParser.getInstance();

    const value =
      urlParser.getParamFromFormData("fapi-form-period") ||
      urlParser.getParam("fapi-form-period");

    if (
      value !== null &&
      value !== "" &&
      periods.find((item) => {
        return item.value === value;
      }) !== undefined
    ) {
      this.value = value;
    }

    this.$emit("periodChanged", this.value);
  },
});
</script>

<style></style>
